import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { Observable } from 'rxjs/internal/Observable';

import { HotMarket } from '../models';

export interface HotMarketApi {
    items: HotMarket[];
    total_count: number;
}

@Injectable({
    providedIn: 'root'
})
export class HotMarketService {
    private _hotMarketRoute = '/api/hot-markets/';
    private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    public pageLayoutBeingViewed: any = {};

    constructor(
        private httpClient: HttpClient,
        private formBuilder: UntypedFormBuilder
    ) { }


    setHotMarketToBeViewed(_hotMarket: any) {
        this.pageLayoutBeingViewed = _hotMarket;
    }


    getHotMarketToBeViewed() {
        return this.pageLayoutBeingViewed;
    }


    get(): Observable<any[]> {
        return this.httpClient.get<any[]>(this._hotMarketRoute);
    }


    getById(_hotMarketId: string): Observable<any> {
        return this.httpClient.get<any>(this._hotMarketRoute + _hotMarketId);
    }


    getByName(pageLayoutName: string): Observable<HotMarket> {
        return this.httpClient.get<HotMarket>(this._hotMarketRoute + 'by-name/' + pageLayoutName);
    }


    create(_hotMarket: HotMarket): Observable<any> {
        return this.httpClient.post<any>(this._hotMarketRoute, JSON.stringify(_hotMarket), this.headerOptions);
    }


    getByPage(searchOptions): Observable<HotMarket[]> {
        return this.httpClient.post<HotMarket[]>(this._hotMarketRoute + 'search-by-page', JSON.stringify(searchOptions), this.headerOptions);
    }


    doRadiusSearch(_marketZip, _radius): Observable<any[]> {
        return this.httpClient.get<any>(this._hotMarketRoute + 'markets-in-radius/' + _marketZip + '/' + _radius);
    }


    selectAllSearch(searchTerms: HotMarket): Observable<any> {
        searchTerms['selectAll'] = true;
        return this.httpClient.post<any>(this._hotMarketRoute + 'dataSourceSearch', JSON.stringify(searchTerms), this.headerOptions);
    }


    getCustomDatasource(searchParams, sortField, sortDirection, pageNumber: number, pageSize: number): Observable<HotMarketApi> {
        searchParams['selectAll'] = false;
        searchParams.sortField = (sortField && sortField !== '') ? sortField : 'createdAt';
        searchParams.sortOrder = (sortDirection && sortDirection !== '') ? sortDirection : 'desc';
        searchParams.pageNumber = (pageNumber && pageNumber !== undefined) ? pageNumber : 0;
        searchParams.pageSize = (pageSize && pageSize !== undefined) ? pageSize : 10;

        return this.httpClient.post<HotMarketApi>(this._hotMarketRoute + 'dataSourceSearch', JSON.stringify(searchParams), this.headerOptions); 
    }


    retrievePlaceIdFromGoogle(searchTerms): Observable<any> {
        return this.httpClient.post(this._hotMarketRoute + 'retrieve-place-id', JSON.stringify(searchTerms), this.headerOptions);
    }


    retrievePlaceDetailsFromGoogle(searchTerms): Observable<any> {
        return this.httpClient.post(this._hotMarketRoute + 'retrieve-place-details', JSON.stringify(searchTerms), this.headerOptions);
    }


    retrievePhotoDataFromGoogle(searchTerms): Observable<any> {
        return this.httpClient.post(this._hotMarketRoute + 'retrieve-photo-data', JSON.stringify(searchTerms), this.headerOptions);
    }


    update(_hotMarket: HotMarket): Observable<any> {
        return this.httpClient.put<any>(this._hotMarketRoute + _hotMarket._id, JSON.stringify(_hotMarket), this.headerOptions);
    }


    updateFieldsById(_id, fieldsToUpdate): Observable<HotMarketApi> {
        return this.httpClient.put<HotMarketApi>(this._hotMarketRoute + 'update-certain-fields-array/' + _id, JSON.stringify(fieldsToUpdate), this.headerOptions);
    }


    markDelete(_id: string): Observable<any> {
        return this.httpClient.put(this._hotMarketRoute + 'mark-deleted/' + _id, this.headerOptions);
    }

    hotMarketFormGroup(formData: HotMarket) {
        return this.formBuilder.group({
            name: [formData.name, Validators.required],
            city: [formData.city, Validators.required],
            state: [formData.state, Validators.required],
            zip: [formData.zip, Validators.required],
            featured: [formData.featured],
            description: [formData.description]
        });
    }
}